document.addEventListener("DOMContentLoaded", () => {
  const tabButtons = document.querySelectorAll(".tab-button");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Remove active class from all buttons and content
      document.querySelectorAll(".tab-button").forEach((btn) => {
        btn.classList.remove("active");
      });

      document.querySelectorAll(".tab-content").forEach((content) => {
        content.classList.remove("active");
      });

      // Add active class to clicked button
      button.classList.add("active");

      // Get the tab to show
      const tabId = button.getAttribute("data-tab");
      const tabContent = document.getElementById(tabId);

      // Add active class to make content visible with fade in
      tabContent.classList.add("active");
    });
  });
});

// Function to animate counting
function animateCounter(element, start, end, duration) {
  let startTime = null;

  // Animation function
  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);

    // Calculate current count value (easing applied)
    const easeProgress = 1 - Math.pow(1 - progress, 3); // Cubic ease-out
    const currentValue = Math.floor(start + easeProgress * (end - start));

    // Update element with comma formatting
    element.textContent = currentValue.toLocaleString();

    // Continue animation if not complete
    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  // Start animation
  requestAnimationFrame(animation);
}

// Intersection Observer to trigger animation when element is visible
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      // If counter section is visible
      if (entry.isIntersecting) {
        const counterElement = document.getElementById("counter");
        const targetValue = parseInt(counterElement.textContent.replace(/,/g, ''), 10) || 0;
        animateCounter(counterElement, 0, targetValue, 2000);
        // Unobserve after triggering once
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.5 }
); // Trigger when 50% of element is visible

// Start observing the counter section
observer.observe(document.getElementById("counterSection"));
